import axios, { AxiosRequestConfig } from 'axios'
import { AuthModel, UserModel } from './_models'
import { getAuth } from './AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/verify_token`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/recuperacion_contrasenia`
export const RESET_PASSWORD_URL = `${API_URL}/recuperacion_contrasenia/cambiar_contrasenia`



const usuario = getAuth();
const config: AxiosRequestConfig = {
  headers: {
    'x-token': `${usuario?.api_token}`,
  },
};

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(correo: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    correo,
  })
}

export function resetPassword(usuarioId: string, password: string) {
  return axios.put<{ result: boolean }>(RESET_PASSWORD_URL, {
    usuarioId,
    password,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  },
    config)
}
